import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ContactInformation from "./sections/ContactInformation";
import ContactForm from "./sections/ContactForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <Hero />
      <ContactInformation />
      <ContactForm />
      <Footer />
    </div>;
}